/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';
import Header from '../Header';
import Footer from '../Footer';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    bareComponent: PropTypes.bool,
  };

  static defaultProps = {
    bareComponent: false,
  };

  render() {
    return (
      <div className={s.container}>
        {this.props.bareComponent ? null : <Header />}
        <div className={s.main}>{this.props.children}</div>
        {this.props.bareComponent ? null : <Footer />}
      </div>
    );
  }
}

export default withStyles(normalizeCss, s)(Layout);
